function generateImageUrls(prefix: string, count: number): string[] {
  const urls = [];
  for (let i = 1; i <= count; i++) {
    urls.push(`assets/img/rooms/${prefix}_${i}.jpg`);
  }
  return urls;
}

export const environment = {
  production: true,
  url: 'https://pulaskiresidence.pl',
  api_url: 'https://domelcki-booking.virtualreception.pl/api/',
  hotel_name: 'Pulaski Residence',
  html_title: '',
  privacy_policy: '',
  hotel_rules: 'https://virtualreception.pl/docs/domelcki',
  mainTitle: "",
  hotel_url: '',
  instagram_url: '',
  facebook_url: '',
  linkedin_url: '',
  asorts: true,
  isBreakfastRequired: false,
  isBreakfastDefaultSelected: false,
  breakfastCheckbox: true,
  localizationSelect: false,
  rabatInput: true,
  isApart: false,
  minimalStayDays: 1,
  localChargeOptionActive: false,
  voucherOptionActive: true,
  offersOptionActive: false,
  breakfastOptionActive: false,
  localCharge: false,
  paymentImagePath: 'assets/img/background.jpg',
  isLanguageChange: false,
  gtm: false,
  gtmtag: '',
  hiddenIcons: false,
  favicon_url: '',
  layoutSettings: {
    footer: {
      addressLine1: '"Dom Ełcki" Spółka z o.o. NIP: 848-170-66-33',
      addressLine2: 'ul. Św. M. M. Kolbe 3/U1 19-300 Ełk',
    },
  },
  messageForNoRooms: 'Brak pokoi w wybranym terminie',
  roomTypeToImagesMap: {
    "11 - Superior + balkon": generateImageUrls('Superior_balkon', 24),
    "23 - Superior + balkon": generateImageUrls('Superior_balkon', 24),
    "12 - Superior": generateImageUrls('12_Superior', 16),
    "24 - Superior": generateImageUrls('12_Superior', 16),
    "14 - Superior": generateImageUrls('14_superior', 24),
    "25 - Superior": generateImageUrls('14_superior', 24),
    "35 - Superior": generateImageUrls('14_superior', 24),
    "42 - Pokój Basic": generateImageUrls('Basic', 11),
    "32 - Pokój Basic": generateImageUrls('Basic', 11),
    "31 - Apartament": generateImageUrls('Apartament', 20),
    "41 - Apartament": generateImageUrls('Apartament', 20),
    "15 - Superior + balkon": generateImageUrls('15_superior', 22),
    "26 - Superior + balkon": generateImageUrls('15_superior', 22),
    "36 - Superior + balkon": generateImageUrls('15_superior', 22),
    "22 - Pokój Classic": generateImageUrls('22_classic', 13),
    "33 - Pokój Classic": generateImageUrls('33_classic', 10),
    "43 - Pokój Classic": generateImageUrls('Pokoj_classic', 20),
    "34 - De Lux": generateImageUrls('De_lux', 22),
    "44 - De Lux + Sauna": generateImageUrls('De_lux_sauna', 19),
    "45 - Superior + balkon": generateImageUrls('45_superior', 17),
    "46 - Superior": generateImageUrls('46_superior', 18),
    "47 - Studio 5-osobowe": generateImageUrls('47_studio', 23),
    "21 - Apartament z tarasem + Aneks": generateImageUrls('Apartament_taras_aneks', 23),
    "Studio 3-osobowe": generateImageUrls('Studio_3osobowe', 14),
    "Studio Love": generateImageUrls('Studio_love', 20),
  },
  roomDetails: true,
  rooms: [{
      type: "Superior z balkonem",
      roomNumbers: [11, 15, 23, 26, 36, 45],
      mainDescription: {
        view: "jezioro",
        bed: "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        extraBed: "rozkładany fotel",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z prysznicem",
        towels: true,
        fridge: true,
        size: 21,
        maxGuests: 3,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
        },
        "roomType": "hotel",
        "view": "visibility",
        "bed": "king_bed",
        "airConditioning": "ac_unit",
        "bathroom": "shower",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "square_foot",
        "maxGuests": "groups"
      },
      detailedEquipment: [
        "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        "rozkładany fotel",
        "TV",
        "internet",
        "toaletka z lustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "zestaw herbata / kawa",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu Superior z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku. Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "Apartament z tarasem",
      roomNumbers: [21],
      mainDescription: {
        features: ["salon z aneksem kuchennym", "taras"],
        bed: "sypialnia z łóżkiem małżeńskim",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z prysznicem",
        towels: true,
        fridge: true,
        size: 32,
        maxGuests: 4,
        elevator: true,
      },
      icons: {
        "roomType": "meeting_room",
        "view": "landscape",
        "bed": "bed",
        "airConditioning": "air",
        "bathroom": "bathroom",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt",
      },
      detailedEquipment: [
        "salon z aneksem kuchennym (lodówka, płyta indukcyjna, piekarnik)",
        "taras",
        "rozkładana kanapa",
        "sypialnia z łóżkiem małżeńskim",
        "TV w salonie oraz sypialni",
        "internet",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem"
      ],
      description: "Spędź wyjątkowy czas w Apartamencie który zachwyca przytulną atmosferą oraz detalami, dzięki którym poczujecie się jak w domu. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku. Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "Pokój Basic",
      roomNumbers: [32, 42],
      mainDescription: {
        features: [],
        bed: "łóżko pojedyncze",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z prysznicem",
        towels: true,
        fridge: true,
        size: 15,
        maxGuests: 1,
        elevator: true,
      },
      icons: {
        "roomType": "meeting_room",
        "view": "landscape",
        "bed": "bed",
        "airConditioning": "air",
        "bathroom": "bathroom",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt",
      },
      detailedEquipment: [
        "łóżko pojedyncze",
        "TV",
        "internet",
        "toaletka z lsustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem",
        "suszarka do włosów"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu Basic który zachwyca przytulną atmosferą oraz detalami, dzięki którym poczujecie się jak w domu. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku. Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "Pokój Classic",
      roomNumbers: [22, 33, 43],
      mainDescription: {
        view: "taras/balkon/okna dachowe",
        bed: "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z prysznicem",
        towels: true,
        fridge: true,
        size: 20,
        maxGuests: 2,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
          "kitchen": "kitchen",
        },
        "view": "visibility",
        "bed": "bed",
        "extraBed": "weekend",
        "airConditioning": "air",
        "bathroom": "shower",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt"
      },
      detailedEquipment: [
        "TV",
        "internet",
        "toaletka z lustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem",
        "suszarka do włosów"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu Classic który zachwyca przytulną atmosferą oraz detalami, dzięki którym poczujecie się jak w domu. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "De Lux",
      roomNumbers: [34],
      mainDescription: {
        features: ["balkon z widokiem na jezioro", "salon z aneksem kuchennym"],
        bed: "sypialnia z łóżkiem małżeńskim",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z wanną",
        towels: true,
        fridge: true,
        size: 45,
        maxGuests: 4,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
          "kitchen": "kitchen",
        },
        "bed": "bed",
        "extraBed": "weekend",
        "airConditioning": "air",
        "bathroom": "bathtub",
        "towels": "bath_towel",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt"
      },
      detailedEquipment: [
        "salon z aneksem kuchennym (lodówka, płyta indukcyjna, piekarnik, zmywarka)",
        "rozkładana kanapa",
        "sypialnia z łóżkiem małżeńskim",
        "TV w salonie oraz sypialni",
        "internet",
        "toaletka z lustrem",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "ręczniki",
        "kosmetyki",
        "łazienka z wanną",
      ],
      description: "Spędź wyjątkowy czas w pokoju typu De Lux z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z wanną zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Aneks kuchenny zapewnia wszystkie niezbędne rzeczy do codziennego funkcjonowania.Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
       {
      type: "Studio",
      roomNumbers: [47],
      mainDescription: {
        features: ["balkon z widokiem na jezioro", "salon z aneksem kuchennym"],
        bed: "sypialnia z łóżkiem małżeńskim",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z wanną",
        towels: true,
        fridge: true,
        size: 45,
        maxGuests: 4,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
          "kitchen": "kitchen",
        },
        "bed": "bed",
        "extraBed": "weekend",
        "airConditioning": "air",
        "bathroom": "bathtub",
        "towels": "bath_towel",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt"
      },
      detailedEquipment: [
        "salon z aneksem kuchennym (lodówka, płyta indukcyjna, piekarnik, zmywarka)",
        "rozkładana kanapa",
        "sypialnia z łóżkiem małżeńskim",
        "TV w salonie oraz sypialni",
        "internet",
        "toaletka z lustrem",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "ręczniki",
        "kosmetyki",
        "łazienka z wanną"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu Studio z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z wanną zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Aneks kuchenny zapewnia wszystkie niezbędne rzeczy do codziennego funkcjonowania.Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "De Lux",
      roomNumbers: [44],
      mainDescription: {
        features: ["balkon z widokiem na jezioro", "salon z aneksem kuchennym"],
        bed: "sypialnia z łóżkiem małżeńskim",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z wanną",
        towels: true,
        fridge: true,
        size: 43,
        maxGuests: 5,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
          "kitchen": "kitchen",
        },
        "bed": "bed",
        "extraBed": "weekend",
        "airConditioning": "air",
        "bathroom": "bathtub",
        "towels": "bath_towel",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt"
      },
      detailedEquipment: [
        "salon z aneksem kuchennym (lodówka, płyta indukcyjna, piekarnik, zmywarka)",
        "rozkładana kanapa",
        "rozkładany fotel",
        "sypialnia z łóżkiem małżeńskim",
        "TV w salonie oraz sypialni",
        "internet",
        "toaletka z lustrem",
        "klimatyzacja indywidualnie sterowana",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem",
        "suszarka do włosów",
        "sauna",
        "pralka",
        "żelazko oraz deska do prasowania"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu De Lux z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku. Pokój zawiera elegancką łazienkę z prysznicem oraz sauną, zaopatrzoną w kosmetyki, ręczniki i suszarkę do włosów. Aneks kuchenny zapewnia wszystkie niezbędne rzeczy do codziennego funkcjonowania. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      "type": "Superior",
      "roomNumbers": [12, 14, 24, 25, 35, 46],
      "mainDescription": {
        "view": "jezioro",
        "bed": "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        "extraBed": "rozkładany fotel",
        "airConditioning": "indywidualnie sterowana",
        "bathroom": "łazienka z prysznicem",
        "towels": true,
        "fridge": true,
        "size": 23,
        "maxGuests": 3,
        elevator: true
      },
      "icons": {
        "roomType": "hotel",
        "view": "visibility",
        "bed": "king_bed",
        "extraBed": "weekend",
        "airConditioning": "ac_unit",
        "bathroom": "shower",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "square_foot",
        "maxGuests": "groups"
      },
      "detailedEquipment": [
        "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        "rozkładany fotel",
        "TV",
        "internet",
        "toaletka z lustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem"
      ],
      "description": "Spędź wyjątkowy czas w pokoju typu Superior z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      "type": "Apartament",
      "roomNumbers": [31, 41],
      "mainDescription": {
        "bedrooms": 2,
        "beds": ["łóżko małżeńskie", "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze"],
        "extraBed": "rozkładany fotel",
        "airConditioning": "indywidualnie sterowana",
        "bathroom": "łazienka z prysznicem",
        "towels": true,
        "fridge": true,
        "size": 27,
        "maxGuests": 5
      },
      "icons": {
        "roomType": "apartment",
        "bedrooms": "meeting_room",
        "bed": "king_bed",
        "extraBed": "weekend",
        "airConditioning": "ac_unit",
        "bathroom": "shower",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "square_foot",
        "maxGuests": "groups"
      },
      "detailedEquipment": [
        "TV",
        "toaletka z lustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów"
      ],
      "description": "Spędź wyjątkowy czas w Apartamencie który zachwyca przytulną atmosferą oraz detalami, dzięki którym poczujecie się jak w domu. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    }
  ],
  cookiesOptionActive: true,
  offersSettings: [{}],
  buttonColor: '#008781',
  showHome: true,
  showFilters: true,
  redirectToOtherHotel: {
    on: false,
    text: ""
  }
};